module.exports = ".close {\n    font-size: 110%;\n    color: white;\n}"